import { Box, FormControl, InputLabel } from "@mui/material";
import { Control, Controller } from "react-hook-form";
import React, { FC } from "react";

import { SwitchCustom } from "../../../styles/styledComponents";

interface ISwitchControlleraProps {
  id?: string;
  name: string;
  label: string;
  control: Control<any>;
  fullWidth?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
}

const SwitchControllera: FC<ISwitchControlleraProps> = ({
  id,
  name,
  label,
  control,
  fullWidth = true,
  defaultChecked = false,
  disabled = false,
}) => {
  const fieldId = id || name;

  return (
    <FormControl fullWidth={fullWidth} style={{ marginBottom: "34px" }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        {label &&
          <InputLabel focused={false} htmlFor={fieldId} sx={{ position: "relative", mt: 2 }}>{label}</InputLabel>
        }
        <Controller
          name={name}
          control={control}
          render={({ field, fieldState }) =>
            <SwitchCustom
              id={fieldId}
              disabled={disabled}
              {...field}
              checked={field.value || defaultChecked}
              color={!!fieldState.error ? "error" : "default"}
              disableRipple
            />
          }
        />
      </Box>
    </FormControl>
  );
};

export default SwitchControllera;
